package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_authentication_data_di_AuthenticationModule : Module get() = module {
	single() { _ -> com.essntl.features.authentication.data.repository.AuthRepositoryImpl(supabase=get()) } bind(com.essntl.features.authentication.domain.repository.AuthRepository::class)
}
public val com.essntl.features.authentication.data.di.AuthenticationModule.module : org.koin.core.module.Module get() = com_essntl_features_authentication_data_di_AuthenticationModule
